import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearZoneAdministrators, createCommunity, getZoneAdministrators } from '../../../actions/userActions'
import { seeListChatCategories } from '../../actions/categoriesActions'
import { CreateZone as CreateZoneView } from '../../containers/Zone/CreateZone/CreateZone'

const CreateZone = ({history}) => {
  const [adminName, setAdminName] = useState("")
  const [adminType, setAdminType] = useState("")
  
  const {usersToAdminZone} = useSelector(state=>state.userInfo)
  const {listChatCategories} = useSelector(state =>state.socialCategoriesAdmin)
  
  const dispatch = useDispatch()
 useEffect(() => {
   
  dispatch(seeListChatCategories())
   return () => {
   
   }
 }, [])
 
  useEffect(() => {
    if(adminName.length>0 & adminType.length>0){
      dispatch( getZoneAdministrators(adminName, adminType))
    }
  
  
    return () => {
      dispatch( clearZoneAdministrators())
    }
  }, [adminName,adminType])
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      description: '',
      categoryId: '',
      adminEntityId: ''
    },
    onSubmit: (values) =>{
      const formData = new FormData();
      for (var key in values) {
          if (key === "picture" && values[key] === "") {

          } else {
              formData.append(key, values[key]);
          }
      }
      dispatch(createCommunity(formData,history))
    }
  })
  return (
    <CreateZoneView formik={formik} adminName={adminName}
      setAdminName={setAdminName}
      adminType={adminType}
      setAdminType={setAdminType}
      usersToAdminZone={usersToAdminZone}
      categories ={listChatCategories}
    />
  )
}

export default CreateZone